import axios from 'axios'

import { getApiUrl } from '../../util/api/api'

const suspendJob = (id: string): Promise<any> => {
  try {
    return axios.put(getApiUrl(`/dashboard/api/job/suspend/${id}`))
  } catch (error) {
    throw new Error(`An error has occurred while suspending a job: ${error.message}`)
  }
}

export default suspendJob
